import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import AreaForm from "../../components/AreaForm/AreaForm";
import useCreateArea from "../../hooks/useCreateArea";
import useAdminRegions from "../../hooks/useAdminRegions";
import useRetailUsers from "../../hooks/useRetailUsers";
import { adaptAreaPayload } from "../../adapters/adaptAreaPayload";

const BACK_PATH = "/users/locations";

const EMPTY_DEFAULTS: AreaFormValues = {
	name: "",
	region: "",
	areaManager: ""
};

const CreateArea = () => {
	const navigate = useNavigate();
	const { mutate: createArea, isLoading } = useCreateArea();
	const { data: regions = [] } = useAdminRegions();
	const { data: retailUsers = [] } = useRetailUsers();

	const handleSubmit = (values: AreaFormValues) => {
		const payload = adaptAreaPayload(values);

		createArea(payload, {
			onSuccess: () => navigate(BACK_PATH)
		});
	};

	return (
		<Page>
			<AreaForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
				regions={regions}
				retailUsers={retailUsers}
				backPath={BACK_PATH}
			/>
		</Page>
	);
};

export default CreateArea;
